/** Asset of
     main-product-add-to-cart.liquid snippet

     main-subscription.liquid
     main-collection-product-grid.liquid
     featured-product.liquid
     main-article.liquid
 sections
 */

if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement
    {
        constructor()
        {
            super();

            this.form = this.querySelector('form');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cartNotification = document.querySelector('cart-notification');
        }

        onSubmitHandler(evt)
        {
            evt.preventDefault();

            const submitButton = this.querySelector('[type="submit"]');
            if (submitButton.classList.contains('loading')) return;

            this.handleErrorMessage();
            this.cartNotification.setActiveElement(document.activeElement);

            submitButton.setAttribute('aria-disabled', true);
            submitButton.classList.add('loading');
            this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);

            // pass a list of liquid files names from sections/ folder
            formData.append(
                'sections',
                this.cartNotification.getSectionsToRender().map((section) => section.id)
            )

            formData.append('sections_url', window.location.pathname);
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                }

                this.cartNotification.renderContents(response);
                document.querySelector('.mini-cart').classList.add('open');
                document.querySelector('body').classList.add('mini-cart-overlay');

                document.querySelector('cart-items')?.classList.toggle('is-empty', response.item_count === 0);
                document.getElementById('main-cart-items')?.classList.toggle('is-empty', response.item_count === 0);
                document.getElementById('main-cart-footer')?.classList.toggle('is-empty', response.item_count === 0);
            }).catch((e) => {
                this.handleErrorMessage(e?.description ?? 'An error occurred while adding the item to your cart. Please try again or contact our support if the problem persists.');
            }).finally(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        }

        handleErrorMessage(errorMessage = false)
        {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(
                '.product-form .error-message-wrapper');
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(
                '.product-form .error-message');

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}